(() => {
  const normalise = (value = '') => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const stopWords = new Set(['le','la','les','de','des','du','un','une','et','pour','avec','sur','dans','quel','quelle','quels','quelles','je','mon','ma','mes','vous','nous','est','que']);
  const tokens = (value) => [...new Set(normalise(value).split(' ').filter((word) => word.length > 2 && !stopWords.has(word)))];
  const escape = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[character]));

  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-resource-question-form]');
    const input = root.querySelector('[data-resource-question-input]');
    const result = root.querySelector('[data-resource-question-result]');
    const data = root.querySelector('[data-resource-question-articles]');
    let articles = [];
    try { articles = JSON.parse(data?.textContent || '[]'); } catch (error) { articles = []; }
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const query = input?.value.trim() || '';
      if (!query) { input?.focus(); return; }
      const terms = tokens(query);
      const matches = articles.map((article) => {
        const title = normalise(article.title);
        const text = normalise(article.text);
        const score = terms.reduce((total, term) => total + (title.includes(term) ? 5 : 0) + (text.includes(term) ? 1 : 0), 0);
        return {...article, score};
      }).filter((article) => article.score > 0).sort((a,b) => b.score - a.score).slice(0,3);
      result.hidden = false;
      if (matches.length) {
        result.innerHTML = '<p>Ces ressources peuvent vous aider :</p><ul>' + matches.map((article) => '<li><a href="' + article.url + '">' + escape(article.title) + '<span aria-hidden="true">→</span></a></li>').join('') + '</ul>';
      } else {
        result.innerHTML = '<div class="cd13-resource-question__fallback"><div><p>Nous n’avons pas trouvé de ressource suffisamment proche.</p><span>Un expert peut vous répondre selon votre projet.</span></div><a href="/pages/contact?question=' + encodeURIComponent(query) + '">Contacter un expert</a></div>';
      }
    });
  };
  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-resource-question]').forEach(init));
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-resource-question]').forEach(init));
})();